// eslint-disable-next-line no-unused-vars
import React, { memo } from 'react';
import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import useRouter from 'Hooks/useRouter';
import StaticBlock from 'Containers/StaticBlock/StaticBlock';

const StylesInformation = styled.div`
  max-width: 1024px;
  margin: auto;
`;

const Information = memo(() => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { params } = useRouter();
  const { bodyAttributes } = Helmet.peek() || {};

  let informationPageClassName = bodyAttributes?.class || '';
  if (!informationPageClassName.includes('Information')) {
    informationPageClassName += 'Information';
  }

  return (
    <>
      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, interactive-widget=resizes-content" />
        <body className={ informationPageClassName } />
        <title>{ t('common.pages.information') }</title>
      </Helmet>
      <StylesInformation theme={ theme } className="grid-container">
        { params?.id ? <StaticBlock id={ params?.id } /> : null }
      </StylesInformation>
    </>
  );
});
Information.displayName = 'InformationPage';

export default Information;
